import './App.css';
import './styles/main.css';
import React, {useEffect} from 'react';

import 'bootstrap-icons/font/bootstrap-icons.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Header from './components/navigation/Header';
import Quiz from './routes/quiz/Quiz';
import {Store} from "./routes/store/Store";
import {Terms} from "./routes/terms/Terms";
import {StoreProduct} from "./routes/store/StoreProduct";
import {Course} from "./routes/course/Course";
import {TestResult} from "./routes/quiz/TestResult";
import {LandingPage} from "./components/LandingPage";
import {HomeDashboard} from "./routes/dashboard/HomeDashboard";
import {UserSettings} from "./routes/dashboard/UserSettings";
import {CourseDashboard} from "./routes/dashboard/CourseDashboard";
import {PurchaseProduct} from "./routes/purchase/PurchaseProduct";
import {Contact} from "./routes/contact/Contact";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Footer} from "./components/navigation/Footer";
import {Faq} from "./routes/faq/Faq";
import {Prices} from "./routes/prices/Prices";
import {SalesTerms} from "./routes/info/SalesTerms";
import {LabCourse} from "./routes/lab/LabCourse";
import {CourseEditor} from "./routes/edit/CourseEditor";
import {PrivacyAgreement} from "./routes/info/PrivacyAgreement";
import NoMatch from "./components/error/NoMatch";
import Upload from "./routes/admin/Upload";
import {ImageAdmin} from "./routes/cms/ImageAdmin";
import {TermAdmin} from "./routes/cms/TermAdmin";
import {QuizAdmin} from "./routes/cms/QuizAdmin";
import {QuizCreation} from "./routes/cms/QuizCreation";
import {PurchaseConfirmation} from "./routes/purchase/PurchaseConfirmation";
import {CoursePreview} from "./routes/course/CoursePreview";
import {CoursePanel} from "./components/panel/CoursePanel";
import {LabCoursePanel} from "./components/panel/LabCoursePanel";
import {QuizPanel} from "./components/panel/QuizPanel";
import {StatsPanel} from "./components/panel/StatsPanel";
import Flashcard from "./components/Flashcard";
import {SubscriptionPanel} from "./components/panel/SubscriptionPanel";
import {ManageSubscription} from "./components/subscription/ManageSubscription";
import {SubscriptionSwitchConfirmation} from "./components/subscription/SubscriptionSwitchConfirmation";
import {ModuleLandingPage} from "./routes/course/ModuleLandingPage";
import {ProductLayout} from "./routes/product/ProductLayout";
import {TaskViewer} from "./routes/cms/TaskViewer";
import {setAccessToken} from "./services/AxiosConfig";
import {useAuth} from "react-oidc-context";
import {PostLogin} from "./routes/login/PostLogin";
import {PrivateRoute} from "./components/auth/PrivateRoute";
import {ActivateProductAgreement} from "./routes/product/ActivateProductAgreement";

function App() {

    const queryClient = new QueryClient()
    const auth = useAuth();

    useEffect(() => {
        if (!auth.isLoading && auth.user?.access_token) {
            setAccessToken(auth.user.access_token)
        }
    }, [auth.isLoading, auth.user]);

    if (auth.isLoading) {
        return <div>Loading..</div>
    }

    return (

        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <Routes>
                    <Route path="/" element={<><Header></Header><LandingPage/></>}></Route>
                    <Route path='/butikk' element={<><Header></Header><Store/></>}></Route>
                    <Route path='/course/preview/:courseName/:moduleName/:chapterName'
                           element={<CoursePreview/>}></Route>
                    <Route path='/course/preview/:courseName' element={<CoursePreview/>}></Route>
                    <Route path='/info/terms' element={<><Header></Header><SalesTerms/></>}></Route>
                    <Route path='/info/privacy' element={<><Header></Header><PrivacyAgreement/></>}></Route>
                    <Route path='/contact' element={<><Header></Header><Contact/></>}></Route>
                    <Route path='/faq' element={<><Header></Header><Faq/></>}></Route>
                    <Route path='/prices' element={<><Header></Header><Prices/></>}></Route>
                    <Route path='/login/verify' element={<PostLogin></PostLogin>}></Route>

                    <Route element={<PrivateRoute/>}>
                        <Route path='/course/edit' element={<><Header></Header><CourseEditor/></>}></Route>
                        <Route path='/hjem' element={<HomeDashboard/>}></Route>

                        <Route path='/produkt/:productName' element={<ProductLayout/>}>
                            <Route path='' element={<CourseDashboard/>}>
                                <Route path={"kurs"} element={<CoursePanel/>}></Route>
                                <Route path={"lab"} element={<LabCoursePanel/>}></Route>
                                <Route path={"quiz"} element={<QuizPanel/>}></Route>
                                <Route path={"evaluering"} element={<StatsPanel/>}></Route>
                                <Route path={"begrep"} element={<Terms/>}></Route>
                                <Route path={"abonnement"} element={<SubscriptionPanel/>}></Route>
                            </Route>
                            <Route path='quiz/:quizName' element={<Quiz/>}></Route>
                            <Route path='quiz/:quizName/result/:id' element={<TestResult/>}></Route>
                            <Route path='kurs/:courseName/:moduleName/:chapterName'
                                   element={<Course/>}></Route>
                            <Route path='kurs/:courseName/:moduleName'
                                   element={<ModuleLandingPage/>}></Route>
                            <Route path='lab/:experiment'
                                   element={<LabCourse/>}></Route>
                            <Route path='abonnement/administrer' element={<ManageSubscription/>}></Route>
                            <Route path='abonnement/administrer/bekreft/:oldTokenId/:newTokenId'
                                   element={<SubscriptionSwitchConfirmation/>}></Route>
                        </Route>
                        <Route path='/butikk/:productName/prov/:courseName/:moduleName/:chapterName'
                               element={<CoursePreview/>}></Route>
                        <Route path='/purchase/:id' element={<PurchaseProduct/>}></Route>
                        <Route path='/purchase/confirm/:id' element={<PurchaseConfirmation/>}></Route>
                        <Route path={"/terms/flashcards/:courseId"} element={<Flashcard/>}/>
                        <Route path='/user/settings' element={<UserSettings/>}></Route>
                    </Route>
                    <Route path='/activate' element={<ActivateProductAgreement/>}></Route>
                    <Route path='/butikk/:productName' element={<StoreProduct/>}></Route>
                    <Route path='/cms/image/upload' element={<Upload/>}></Route>
                    <Route path='/cms/image/admin' element={<ImageAdmin/>}></Route>
                    <Route path='/cms/term/admin' element={<TermAdmin/>}></Route>
                    <Route path='/cms/quiz/admin' element={<QuizAdmin/>}></Route>
                    <Route path='/cms/task/:id' element={<TaskViewer/>}></Route>
                    <Route path='/cms/quiz/create' element={<QuizCreation/>}></Route>
                    <Route path={"*"} element={<><Header/><NoMatch/></>}></Route>
                </Routes>
                <Footer/>
            </QueryClientProvider>
        </BrowserRouter>
    );
}

export default App;
